import { db } from "./config";
import { doc, collection, query, onSnapshot } from "firebase/firestore";

/**
 * Suscribirse a un documento en tiempo real.
 */
export const subscribeToDocument = (
  collectionName,
  id,
  callback,
  converter = null
) => {
  const docRef = converter
    ? doc(db, collectionName, id).withConverter(converter)
    : doc(db, collectionName, id);
  return onSnapshot(docRef, (docSnap) => {
    callback(docSnap.exists() ? docSnap.data() : null);
  });
};

/**
 * Suscribirse a una colección en tiempo real (con o sin condiciones).
 */
export const subscribeToCollection = (
  collectionName,
  conditions = [],
  callback,
  converter = null
) => {
  const colRef = converter
    ? collection(db, collectionName).withConverter(converter)
    : collection(db, collectionName);
  const q = query(colRef, ...conditions);
  return onSnapshot(q, (querySnapshot) => {
    callback(
      querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        _id: doc.id,
        _ref: collectionName,
      }))
    );
  });
};
